export default (table) => {
  const wrapper = document.createElement('div')

  wrapper.classList.add('scrollable-table')
  table.parentNode.insertBefore(wrapper, table)
  wrapper.appendChild(table)
}
